import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";

export const ethereum = satisfies<ChainConfig>()({
  tokens: {
    [TOKEN_ADDRESS.ethereum.LQTY]: {
      name: "Liquity",
    },
    [TOKEN_ADDRESS.ethereum.ETH_cbETH]: {
      symbol: "ETH/cbETH",
      name: "Curve LP",
    },
    [TOKEN_ADDRESS.ethereum.ETH_stETH]: {
      symbol: "ETH/stETH",
      name: "Curve LP",
    },
    [TOKEN_ADDRESS.ethereum.FRAX_USDC]: {
      symbol: "FRAX/USDC",
      name: "Curve LP",
    },
    [TOKEN_ADDRESS.ethereum.LUSD_3CRV]: {
      symbol: "LUSD/3CRV",
      name: "Curve LP",
    },
    [TOKEN_ADDRESS.ethereum.stETH_NG]: {
      symbol: "ETH/stETH-ng",
      name: "Curve LP",
    },
    [TOKEN_ADDRESS.ethereum.PTezETH]: {
      symbol: "PT-ezETH (25 Apr)",
      name: "Renzo • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.ezETH]: {
      name: "Renzo",
    },
    [TOKEN_ADDRESS.ethereum.PTrswETH]: {
      name: "Swell • Pendle",
      symbol: "PT-rswETH (27 Jun)",
    },
    [TOKEN_ADDRESS.ethereum.rsETH]: {
      name: "Kelp",
    },
    [TOKEN_ADDRESS.ethereum.PTrsETH]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (27 Jun)",
    },
    [TOKEN_ADDRESS.ethereum.PTweETH]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (27 Jun)",
    },
    [TOKEN_ADDRESS.ethereum.PTezETH_DEC2024]: {
      symbol: "PT-ezETH (26 Dec)",
      name: "Renzo • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PT_ezETH_26SEP2024]: {
      symbol: "PT-ezETH (26 Sep)",
      name: "Renzo • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PT_weETH_26SEP2024]: {
      symbol: "PT-eETH (26 Sep)",
      name: "Etherfi • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PT_sUSDE_26SEP2024]: {
      symbol: "PT-sUSDE (26 Sep)",
      name: "Ethena • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PT_pufETH_26SEP2024]: {
      symbol: "PT-pufETH (26 Sep)",
      name: "Puffer • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PTweETH_DEC2024]: {
      symbol: "PT-eETH (26 Dec)",
      name: "Etherfi • Pendle",
    },
    [TOKEN_ADDRESS.ethereum.PTrsETH_DEC2024]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (26 Dec)",
    },
    [TOKEN_ADDRESS.ethereum.PTpufETH_DEC2024]: {
      symbol: "PT-pufETH (26 Dec)",
      name: "Puffer • Pendle",
    },
  },
} as const);
